<template>
    <button
        @click="$emit('click')"
        :class="
            [
                `
                    absolute
                    top-0
                    right-6
                    bottom-0
                    z-50
                    m-auto
                    flex
                    focus:outline-none
                    items-center
                    justify-center
                    lg:hidden
                    menu-button
                    outline-none
                `,
                {
                    open: isOpen,
                },
            ]
        "
        aria-label="Toggle mobile menu"
    >
        <div class="menu-button-inner">
            <span />
            <span />
            <span />
            <span />
        </div>
    </button>
</template>

<script>
export default {
    name: 'NavigationMenuButton',
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
    .menu-button {
        width: 48px;
        height: 48px;
        transition: 0.5s ease-in-out;

        &-inner {
            position: relative;
            width: 24px;
            height: 16px;
        }

        span {
            position: absolute;
            left: 0;
            display: block;
            width: 100%;
            height: 1px;
            background: theme('colors.white');
            transition: 0.25s ease-in-out;

            &:nth-child(1) {
                top: 0;
            }

            &:nth-child(2),
            &:nth-child(3) {
                top: 7px;
            }

            &:nth-child(4) {
                top: 14px;
            }
        }

        &.open span {
            background: theme('colors.white');

            &:nth-child(1) {
                top: 7px;
                left: 50%;
                width: 0;
            }

            &:nth-child(2) {
                transform: rotate(45deg);
            }

            &:nth-child(3) {
                transform: rotate(-45deg);
            }

            &:nth-child(4) {
                top: 7px;
                left: 50%;
                width: 0;
            }
        }
    }
</style>
